import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SubscriptionListEntity } from '../components/depot-creation-modal/available-subscriptions-list.entity';
import { DepotConfigSliceKey } from './depot-config.state';
import { DepotRootState, featureSelector } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[DepotConfigSliceKey]
);

const subscriptionsListSelector = createSelector(
	baseSelector,
	(state) => state.subscriptionsForDepotCreation
);

@Injectable()
export class DepotConfigSelector {
	public constructor(private readonly store: Store<DepotRootState>) {}

	public getAvailableSubscriptionsForDepotCreation$(): Observable<SubscriptionListEntity | null> {
		return this.store.pipe(select(subscriptionsListSelector));
	}
}
